import { jsx as _jsx } from "react/jsx-runtime";
import IMask from 'imask';
import { forwardRef, useCallback, useRef, useState } from 'react';
import { BKJTextInput } from '../BKJTextInput/index.js';
export const BKJPhoneNumberInput = forwardRef((props, ref) => {
    const { onChange, value = '', name, maxLength, type, inputMode, ...rest } = props;
    const effectiveType = type ?? 'tel';
    const effectiveInputMode = inputMode ?? 'tel';
    const inputRef = useRef(null);
    let mask = '';
    if (maxLength) {
        switch (true) {
            case maxLength >= 12:
                mask = '(000) 000-0000-00';
                break;
            case maxLength === 11:
                mask = '(000) 000-0000-0';
                break;
            default:
                mask = '(000) 000-0000';
        }
    }
    const formatPhoneNumber = IMask.createMask({
        mask: mask,
    });
    const [displayValue, setDisplayValue] = useState(formatPhoneNumber.resolve(value));
    const handleChange = useCallback((e) => {
        if (onChange) {
            const input = e.target;
            const cursorPosition = input.selectionStart ?? 0;
            const oldValue = displayValue;
            const rawInputValue = e.target.value;
            formatPhoneNumber.resolve(rawInputValue);
            const newDisplayValue = formatPhoneNumber.value;
            const isDeleting = rawInputValue.length < oldValue.length;
            let newCursorPosition;
            if (isDeleting) {
                newCursorPosition = cursorPosition;
            }
            else {
                const addedFormattingChars = newDisplayValue.length - rawInputValue.length;
                newCursorPosition = Math.min(cursorPosition + addedFormattingChars, newDisplayValue.length);
            }
            setDisplayValue(newDisplayValue);
            requestAnimationFrame(() => {
                if (inputRef.current) {
                    inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            });
            e.target.value = formatPhoneNumber.unmaskedValue;
            onChange(e);
        }
    }, [formatPhoneNumber, onChange, displayValue]);
    const setRefs = useCallback((node) => {
        inputRef.current = node;
        if (typeof ref === 'function') {
            ref(node);
        }
        else if (ref) {
            ref.current = node;
        }
    }, [ref]);
    return (_jsx(BKJTextInput, { ...rest, type: effectiveType, inputMode: effectiveInputMode, name: name, ref: setRefs, value: displayValue, onChange: handleChange }));
});
//# sourceMappingURL=BKJPhoneNumberInput.js.map